const confinesDescriptions = [
  {
    name: 'Не опасные явления',
    min: {
      tagName: 'minDangerous',
      name: 'Минимальное значение',
    },
    max: {
      tagName: 'maxDangerous',
      name: 'Максимальное значение',
    },
  },
  {
    name: 'Допустимые значения',
    min: {
      tagName: 'minForbidden',
      name: 'Минимальное допустимое значение',
    },
    max: {
      tagName: 'maxForbidden',
      name: 'Максимально допустимое значение',
    },
  },
  {
    name: 'Предупреждения Hydropad',
    min: {
      tagName: 'minHPWarning',
      name: 'Минимальная граница предупреждения Hydropad',
    },
    max: {
      tagName: 'maxHPWarning',
      name: 'Максимальная граница предупреждения Hydropad',
    },
  },
  {
    name: 'Штатный режим',
    min: {
      tagName: 'minStormMode',
      name: 'Минимальное значение',
    },
    max: {
      tagName: 'maxStormMode',
      name: 'Максимальное значение',
    },
  },
  {
    name: 'Точность округления после запятой',
    tagName: 'precision',
  },
];

// export const timeError = {
//   timeError: 'Допустимая погрешность во времени',
//   validation: {
//     max: 30,
//     min: 0,
//   },
// };

export default confinesDescriptions;
